export default __webpack_public_path__ + "static/media/face.d892afdc.svg";